import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Create a new coupon
export const createBanner = async (couponData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.BANNERS.CREATE, couponData);
    return response.data;
  } catch (error) {
    console.error('Error creating coupon:', error);
    throw error;
  }
};

// Update an existing coupon
export const updateBanner = async (bannerId, updateData) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.BANNERS.UPDATE}/${bannerId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating coupon:', error);
    throw error;
  }
};

// Get all coupons with optional query parameters
export const getBanners = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams?.page || 1,
      search: queryParams?.search || '',
      sortBy: queryParams?.sortBy || 'createdAt',
      type: queryParams?.type || '',
    };

    const response = await axiosInstance.get(API_ROUTES.BANNERS.GET, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching coupons:', error);
    throw error;
  }
};
export const getAllBanners = async () => {
  try {

    const response = await axiosInstance.get(API_ROUTES.BANNERS.GET_ALL_BANNER);
    return response.data;
  } catch (error) {
    console.error('Error fetching coupons:', error);
    throw error;
  }
};

export const getBanner = async (bannerId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.BANNERS.GET_SINGLE_BANNER}/${bannerId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching coupon:', error);
    throw error;
  }
};

// Delete one or multiple coupons
export const deleteBanners = async (couponIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.BANNERS.DELETE, {
      data: {
        ids: couponIds // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting coupons:', error);
    throw error;
  }
};

const bannnerApi = {
  createBanner,
  updateBanner,
  getBanners,
  deleteBanners,
  getBanner
};

export default bannnerApi;